module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.global.title)
    }
  }), _vm._v(" "), (_vm.$store.state.user.userinfo.username) ? _c('span', {
    staticClass: "logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "userinfo",
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.user.userinfo.username || "登录")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-8c0c10f8"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/HeadNav/HeadNav.vue
// module id = 94
// module chunks = 1